import apiClient from "./axiosInstance";
import Swal from "sweetalert2";
// export const fetchUsers = () => {
//   return axiosInstance.get('/users');
// };

export const cof = async (cofData) => {
  try {
    // Make the API call
    const response = await apiClient.post("/cofDetails", cofData);
    return response; // Return the successful response
  } catch (error) {
    // Log or handle the error

    Swal.fire({
      title: "Already Added!",
      text: "COF Already Added!",
      icon: "warning",
      confirmButtonText: "OK",
    });

    console.error("Error posting COF details:", error);
    throw new Error("Failed to post COF details"); // Throw an error or return an error message
  }
};

export const fetchFishermenDetails = async (validIds) => {
  const results = [];

  for (const userId of validIds) {
    try {
      const res = await fetch(
        `https://api.starmarketapi.online/fisherman1/fisherman/userid/${userId}`
      );
      if (!res.ok) {
        console.error(`Failed to fetch userId ${userId}: ${res.status}`);
        continue;
      }

      const data = await res.json();
      results.push(data);
    } catch (err) {
      console.error(`Error fetching userId ${userId}:`, err);
    }
  }

  return results;
};

export const cofRequest = async (cofData) => {
  return await apiClient.post("/cofRequest/upsert", cofData);
};

export const getOccupiedSlots = async (date, officer) => {
  return await apiClient.get(`/getTimeSlotsForDate/${date}/${officer}`);
};

export const fetchCofs = async () => {
  return await apiClient.get("/cofDetails");
};

export const getCofByVesselId = async (data) => {
  return await apiClient.get(`/cofDetails/${data}`);
};

export const getCofRequests = async (id) => {
  return await apiClient.get(`/cofRequests/${id}`);
};

export const getCofRequestsOfficer = async (officerId) => {
  return await apiClient.get(`/cofRequests2/${officerId}`);
};

export const getCofByTripId = async (tripId) => {
  return await apiClient.get(`/cofRequest3/${tripId}`);
};

export const deleteCofRequest = async (id) => {
  return await apiClient.delete(`/cofRequest/${id}`);
};

export const checkCof = async (requestId) => {
  return await apiClient.get(`/checkCof/${requestId}`);
};

export const checkSustainability = async (requestId) => {
  //alert("Checking sustainability for request ID: " + requestId);
  return await apiClient.get(`/checkSutainability/${requestId}`);
};

export const checkEnvironment = async (requestId) => {
  //alert("Checking sustainability for request ID: " + requestId);
  return await apiClient.get(`/checkEnvironment/${requestId}`);
};

export const checkSafetyp = async (requestId) => {
  //alert("Checking sustainability for request ID: " + requestId);
  return await apiClient.get(`/checkSafetyp/${requestId}`);
};

export const checkSafetyc = async (requestId) => {
  //alert("Checking sustainability for request ID: " + requestId);
  return await apiClient.get(`/checkSafetyc/${requestId}`);
};

export const checkILO = async (requestId) => {
  //alert("Checking sustainability for request ID: " + requestId);
  return await apiClient.get(`/checkILO/${requestId}`);
};

export const updateCofRequestStatus = async (cofId, statusData) => {
  return await apiClient.patch(`/cofRequests2/${cofId}`, statusData);
};

export const sustainability = async (sustainabilityData) => {
  try {
    // Make the API call
    const response = await apiClient.post(
      "/sustainability",
      sustainabilityData
    );
    return response; // Return the successful response
  } catch (error) {
    // Log or handle the error

    Swal.fire({
      title: "Already Added!",
      text: "Sustainability Already Added!",
      icon: "warning",
      confirmButtonText: "OK",
    });

    console.error("Error posting COF details:", error);
    throw new Error("Failed to post COF details"); // Throw an error or return an error message
  }
};

export const safetyp = async (safetypData) => {
  try {
    // Make the API call
    const response = await apiClient.post("/safetyp", safetypData);
    return response; // Return the successful response
  } catch (error) {
    // Log or handle the error

    Swal.fire({
      title: "Already Added!",
      text: "Safety Personnel Already Added!",
      icon: "warning",
      confirmButtonText: "OK",
    });

    console.error("Error posting safety personnel details:", error);
    throw new Error("Failed to post safety personnel details"); // Throw an error or return an error message
  }
};

export const environment = async (environmentData) => {
  try {
    // Make the API call
    const response = await apiClient.post("/environment", environmentData);
    return response; // Return the successful response
  } catch (error) {
    // Log or handle the error

    Swal.fire({
      title: "Already Added!",
      text: "Sustainability Already Added!",
      icon: "warning",
      confirmButtonText: "OK",
    });

    console.error("Error posting COF details:", error);
    throw new Error("Failed to post COF details"); // Throw an error or return an error message
  }
};

export const safetyc = async (safetycData) => {
  try {
    // Make the API call
    const response = await apiClient.post("/safetyc", safetycData);
    return response; // Return the successful response
  } catch (error) {
    // Log or handle the error

    Swal.fire({
      title: "Already Added!",
      text: "Safety Craft Already Added!",
      icon: "warning",
      confirmButtonText: "OK",
    });

    console.error("Error posting safety craft details:", error);
    throw new Error("Failed to post safety craft details"); // Throw an error or return an error message
  }
};

export const ilo = async (iloData) => {
  try {
    // Make the API call
    const response = await apiClient.post("/ilo", iloData);
    return response; // Return the successful response
  } catch (error) {
    // Log or handle the error

    Swal.fire({
      title: "Already Added!",
      text: "ILO C188 Already Added!",
      icon: "warning",
      confirmButtonText: "OK",
    });

    console.error("Error posting ilo details:", error);
    throw new Error("Failed to post ilo details"); // Throw an error or return an error message
  }
};
